var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path6, _path7, _path8, _path9, _rect, _path0, _path1, _path10, _path11, _path12, _path13, _rect2, _rect3, _path14, _path15, _path16, _path17, _path18, _path19, _rect4, _rect5, _path20, _path21, _path22, _path23, _path24, _path25, _rect6, _rect7, _path26, _path27, _path28, _path29, _path30, _path31, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContrastShower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 150,
    viewBox: "0 0 277 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 141C93.6995 141 74 121.301 74 97C74 72.6995 93.6995 53 118 53C142.301 53 162 72.6995 162 97C162 121.301 142.301 141 118 141Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116 112C89.4903 112 68 90.5097 68 64C68 37.4903 89.4903 16 116 16C142.51 16 164 37.4903 164 64C164 90.5097 142.51 112 116 112Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157 150C130.49 150 109 128.51 109 102C109 75.4903 130.49 54 157 54C183.51 54 205 75.4903 205 102C205 128.51 183.51 150 157 150Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173 109C148.699 109 129 89.3005 129 65C129 40.6995 148.699 21 173 21C197.301 21 217 40.6995 217 65C217 89.3005 197.301 109 173 109Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148 106C119.281 106 96 82.7188 96 54C96 25.2812 119.281 2 148 2C176.719 2 200 25.2812 200 54C200 82.7188 176.719 106 148 106Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 248 135)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 52 11)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 80 141)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 3 56)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 189 0)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 277 68)",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23L31.5 28",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 136L30 130.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M254.5 31.5L275 27.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M233 102L251 106.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 196.396,
    y: 11.3145,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(2 196.396 11.3145)",
    fill: "#57A1F7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M219.564 42.1418C219.534 42.991 218.822 43.6553 217.973 43.6256C217.124 43.596 216.459 42.8836 216.489 42.0344C216.543 40.4969 218.121 39.3974 218.121 39.3974C218.121 39.3974 219.618 40.6043 219.564 42.1418Z",
    fill: "#24284E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M214.183 41.9543C214.154 42.8035 213.441 43.4678 212.592 43.4381C211.743 43.4085 211.079 42.6961 211.108 41.8469C211.162 40.3094 212.74 39.2099 212.74 39.2099C212.74 39.2099 214.237 40.4168 214.183 41.9543Z",
    fill: "#24284E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M211.296 36.466C211.266 37.3152 210.553 37.9795 209.704 37.9499C208.855 37.9202 208.191 37.2078 208.22 36.3586C208.274 34.8211 209.852 33.7217 209.852 33.7217C209.852 33.7217 211.349 34.9285 211.296 36.466Z",
    fill: "#24284E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M217.062 36.6672C217.032 37.5163 216.32 38.1807 215.471 38.151C214.622 38.1214 213.957 37.409 213.987 36.5598C214.041 35.0223 215.619 33.9228 215.619 33.9228C215.619 33.9228 217.116 35.1297 217.062 36.6672Z",
    fill: "#24284E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M222.828 36.8684C222.798 37.7175 222.086 38.3818 221.237 38.3522C220.387 38.3225 219.723 37.6101 219.753 36.761C219.806 35.2235 221.384 34.124 221.384 34.124C221.384 34.124 222.881 35.3308 222.828 36.8684Z",
    fill: "#24284E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M226.448 31.6059C226.463 32.0304 226.104 32.3637 225.68 32.3488L205.692 31.6508C205.267 31.636 204.932 31.2786 204.977 30.8561C205.566 25.2846 210.376 21.0386 216.061 21.2372C221.747 21.4357 226.249 26.0069 226.448 31.6059Z",
    fill: "#24284E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 214.577,
    y: 19.6465,
    width: 3.07692,
    height: 3.07692,
    rx: 0.769231,
    transform: "rotate(2 214.577 19.6465)",
    fill: "#24284E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 178.788,
    y: 90.2988,
    width: 36,
    height: 36,
    rx: 18,
    transform: "rotate(-4 178.788 90.2988)",
    fill: "#57A1F7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M202.426 115.712C202.479 116.475 201.904 117.137 201.141 117.19C200.378 117.243 199.717 116.668 199.663 115.905C199.567 114.524 200.875 113.392 200.875 113.392C200.875 113.392 202.329 114.331 202.426 115.712Z",
    fill: "#24284E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M197.592 116.05C197.645 116.813 197.07 117.475 196.307 117.528C195.544 117.581 194.883 117.006 194.829 116.243C194.733 114.862 196.041 113.73 196.041 113.73C196.041 113.73 197.495 114.669 197.592 116.05Z",
    fill: "#24284E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M194.491 111.408C194.544 112.17 193.969 112.832 193.206 112.885C192.444 112.939 191.782 112.364 191.729 111.601C191.632 110.22 192.941 109.087 192.941 109.087C192.941 109.087 194.394 110.026 194.491 111.408Z",
    fill: "#24284E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M199.671 111.046C199.724 111.809 199.149 112.471 198.386 112.524C197.623 112.577 196.962 112.002 196.908 111.239C196.812 109.858 198.121 108.726 198.121 108.726C198.121 108.726 199.574 109.665 199.671 111.046Z",
    fill: "#24284E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M204.85 110.685C204.904 111.448 204.329 112.109 203.566 112.163C202.803 112.216 202.141 111.641 202.088 110.878C201.991 109.497 203.3 108.364 203.3 108.364C203.3 108.364 204.754 109.304 204.85 110.685Z",
    fill: "#24284E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M207.596 105.635C207.65 106.014 207.36 106.346 206.978 106.373L189.022 107.628C188.641 107.655 188.307 107.366 188.307 106.984C188.311 101.942 192.216 97.6889 197.324 97.3317C202.432 96.9746 206.891 100.643 207.596 105.635Z",
    fill: "#24284E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 195.846,
    y: 96.0469,
    width: 2.76923,
    height: 2.76923,
    rx: 0.692308,
    transform: "rotate(-4 195.846 96.0469)",
    fill: "#24284E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37.3145,
    y: 69.7109,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(-2 37.3145 69.7109)",
    fill: "#57A1F7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5772 98.847C62.6069 99.6961 61.9425 100.409 61.0934 100.438C60.2442 100.468 59.5318 99.8035 59.5022 98.9543C59.4485 97.4168 60.9457 96.21 60.9457 96.21C60.9457 96.21 62.5235 97.3094 62.5772 98.847Z",
    fill: "#24284E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1964 99.0345C57.226 99.8836 56.5617 100.596 55.7125 100.626C54.8634 100.655 54.151 99.991 54.1213 99.1418C54.0676 97.6043 55.5649 96.3975 55.5649 96.3975C55.5649 96.3975 57.1427 97.4969 57.1964 99.0345Z",
    fill: "#24284E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9327 93.761C53.9623 94.6102 53.298 95.3226 52.4488 95.3522C51.5997 95.3819 50.8873 94.7176 50.8576 93.8684C50.8039 92.3309 52.3012 91.124 52.3012 91.124C52.3012 91.124 53.879 92.2235 53.9327 93.761Z",
    fill: "#24284E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6993 93.5598C59.7289 94.409 59.0646 95.1214 58.2154 95.1511C57.3663 95.1807 56.6539 94.5164 56.6242 93.6672C56.5705 92.1297 58.0678 90.9229 58.0678 90.9229C58.0678 90.9229 59.6456 92.0223 59.6993 93.5598Z",
    fill: "#24284E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4649 93.3587C65.4946 94.2078 64.8302 94.9202 63.9811 94.9499C63.1319 94.9795 62.4195 94.3152 62.3899 93.4661C62.3362 91.9285 63.8334 90.7217 63.8334 90.7217C63.8334 90.7217 65.4112 91.8212 65.4649 93.3587Z",
    fill: "#24284E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7096 87.8563C68.7543 88.2788 68.4193 88.6363 67.9947 88.6511L48.0069 89.3491C47.5823 89.3639 47.2232 89.0307 47.2383 88.6061C47.4375 83.0072 51.9394 78.436 57.625 78.2374C63.3105 78.0389 68.1203 82.2849 68.7096 87.8563Z",
    fill: "#24284E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56.0332,
    y: 76.7539,
    width: 3.07692,
    height: 3.07692,
    rx: 0.769231,
    transform: "rotate(-2 56.0332 76.7539)",
    fill: "#24284E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 24,
    width: 104,
    height: 104,
    rx: 52,
    fill: "#57A1F7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M154 102C154 104.209 152.209 106 150 106C147.791 106 146 104.209 146 102C146 98 150 95 150 95C150 95 154 98 154 102Z",
    fill: "#24284E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M140 102C140 104.209 138.209 106 136 106C133.791 106 132 104.209 132 102C132 98 136 95 136 95C136 95 140 98 140 102Z",
    fill: "#24284E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M132 88C132 90.2091 130.209 92 128 92C125.791 92 124 90.2091 124 88C124 84 128 81 128 81C128 81 132 84 132 88Z",
    fill: "#24284E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M147 88C147 90.2091 145.209 92 143 92C140.791 92 139 90.2091 139 88C139 84 143 81 143 81C143 81 147 84 147 88Z",
    fill: "#24284E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M162 88C162 90.2091 160.209 92 158 92C155.791 92 154 90.2091 154 88C154 84 158 81 158 81C158 81 162 84 162 88Z",
    fill: "#24284E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M170.93 73.9997C171.007 75.1015 170.105 76 169 76H117C115.895 76 114.993 75.1015 115.07 73.9997C116.096 59.4693 128.209 48 143 48C157.791 48 169.904 59.4693 170.93 73.9997Z",
    fill: "#24284E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 44,
    width: 8,
    height: 8,
    rx: 2,
    fill: "#24284E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrastShower);
export default __webpack_public_path__ + "static/media/contrast-shower.56eba840d6d5e49402f26e1abd52d645.svg";
export { ForwardRef as ReactComponent };